var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90009 0.9999C10.0863 1.18726 10.1909 1.44071 10.1909 1.7049C10.1909 1.96909 10.0863 2.22254 9.90009 2.4099L3.32009 8.9999L10.0001 15.6599C10.1863 15.8473 10.2909 16.1007 10.2909 16.3649C10.2909 16.6291 10.1863 16.8825 10.0001 17.0699C9.90712 17.1636 9.79652 17.238 9.67466 17.2888C9.5528 17.3396 9.4221 17.3657 9.29009 17.3657C9.15808 17.3657 9.02737 17.3396 8.90551 17.2888C8.78365 17.238 8.67305 17.1636 8.58009 17.0699L1.19009 9.7099C1.09636 9.61694 1.02196 9.50634 0.971194 9.38448C0.920426 9.26262 0.894287 9.13191 0.894287 8.9999C0.894287 8.86789 0.920426 8.73718 0.971194 8.61532C1.02196 8.49346 1.09636 8.38286 1.19009 8.2899L8.48009 0.9999C8.57305 0.906171 8.68365 0.831777 8.80551 0.781008C8.92737 0.73024 9.05807 0.704102 9.19009 0.704102C9.3221 0.704102 9.4528 0.73024 9.57466 0.781008C9.69652 0.831777 9.80712 0.906171 9.90009 0.9999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowLeft);
export default __webpack_public_path__ + "static/media/keyboard_arrow_left.ac20e2f1396156f37382fbaa699a23b6.svg";
export { ForwardRef as ReactComponent };